import type * as React from 'react';
import { createContext, useEffect, useMemo, useState } from 'react';

interface IAppWindowStyleContext {
  isPopupOpen: boolean;
  setIsPopupOpen: (isPopupOpen: boolean) => void;
}

export const POPUP_WINDOW = 'conferWindow';

export enum ChatWindowOpenStyle {
  WINDOW = 'WINDOW',
  MODEL = 'MODEL'
}

export const AppWindowStyleContext = createContext<IAppWindowStyleContext>({} as IAppWindowStyleContext);

const AppWindowStyleProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [conferWindow, setConferWindow] = useState<Window | null>();

  useEffect(() => {
    let timer: NodeJS.Timer;
    if (conferWindow) {
      timer = setInterval(() => {
        if (conferWindow.closed) {
          clearInterval(timer);
          setIsPopupOpen(false);
        }
      }, 1000);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [conferWindow]);

  useEffect(() => {
    if (isPopupOpen) {
      const viewportWidth = document.documentElement.clientWidth + window.screenLeft;
      const viewportHeight = document.documentElement.clientHeight - 540;
      //TODO: SIZE need to change
      const windowFeatures = `location=0,menubar=0,status=0,scrollbars=0,resizable=0,left=${viewportWidth},top=${viewportHeight},width=360,height=580`;

      const openedWindow: Window | null = window.open(
        `${window.location.href}?${POPUP_WINDOW}=true`,
        POPUP_WINDOW,
        windowFeatures
      );
      openedWindow?.focus();
      setConferWindow(openedWindow);
    } else {
      conferWindow?.close();
    }
  }, [isPopupOpen]);

  const initialValue = useMemo(() => ({ isPopupOpen, setIsPopupOpen }), [isPopupOpen, setIsPopupOpen]);

  return <AppWindowStyleContext.Provider value={initialValue}>{children}</AppWindowStyleContext.Provider>;
};
export default AppWindowStyleProvider;
